import {GET_ALLBUSINESSCATEGORY_FAILED, GET_ALLBUSINESSCATEGORY_LOADING, GET_ALLBUSINESSCATEGORY_SUCCESS } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    data: null,
  };
  
  export const getAllBusinessCategoryReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    
    switch (action.type) {
      case GET_ALLBUSINESSCATEGORY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_ALLBUSINESSCATEGORY_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
          error: null,
        };
      case GET_ALLBUSINESSCATEGORY_FAILED:
        return {
          ...state,
          loading: false,
          data: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  